import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import ProductCombination from '@/components/views/productView/ProductCombination.vue';

/* === Props, Emits & State === */

export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsSelectorPopup',
  props: {
    productData: { required: true },
},
  emits: ['combinationsSelectorClosed', 'updateHiddenIndices', 'addNewCombination'],
  setup(__props, { emit }) {




const visible = ref(false);
const productsSelectedForCombination = ref<number[]>([]);
const isTooltipVisible = ref(false);

function openPopup() {
    visible.value = true;
    updateHiddenIndices();
}

function closePopup() {
    productsSelectedForCombination.value = [];
    visible.value = false;
    emit('combinationsSelectorClosed');
}

function updateHiddenIndices() {
    emit('updateHiddenIndices');
}

function tooltipVisibilityChange(active: boolean) {
    if (isCombinationModalAdditionDisabled.value) {
        isTooltipVisible.value = active;
    } else {
        isTooltipVisible.value = false;
    }
}

async function addNewCombination() {
    emit('addNewCombination', productsSelectedForCombination.value);

    await nextTick();

    productsSelectedForCombination.value = [];
    EventBus.$emit(EventBusEvents.resetCombinationProductSelectionStatus);
    closePopup();
}

const isCombinationModalAdditionDisabled = computed(
    () => !(productsSelectedForCombination.value.length > 1 && productsSelectedForCombination.value.length < 5),
);

/* === Lifecycle === */
onMounted(() => {
    EventBus.$on(EventBusEvents.openCombinationsSelectorPopup, openPopup);
    EventBus.$on(EventBusEvents.closeContactPopup, closePopup);
});

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.openCombinationsSelectorPopup, openPopup);
    EventBus.$off(EventBusEvents.closeContactPopup, closePopup);
});

return { __sfc: true,emit, visible, productsSelectedForCombination, isTooltipVisible, openPopup, closePopup, updateHiddenIndices, tooltipVisibilityChange, addNewCombination, isCombinationModalAdditionDisabled, ProductCombination }
}

})